import KeyboardFocusable from '../KeyboardFocusable';

import Controls from './Controls';

export default class ChatIGallery extends Controls {
    namespace = 'chatGallery';
    constructor() {
        super();
    }

    init() {
        this.prevBtnEl = document.querySelector('.ril__navButtonPrev');
        this.nextBtnEl = document.querySelector('.ril__navButtonNext');
        if (this.prevBtnEl) {
            this._prevBtn = new KeyboardFocusable(this.prevBtnEl);
        }
        if (this.nextBtnEl) {
            this._nextBtn = new KeyboardFocusable(this.nextBtnEl);
        }
    }

    destroy() {
        this.prevBtnEl = null;
        this.nextBtnEl = null;
    }

    isPossibleUp() {
        return false;
    }

    isPossibleDown() {
        return false;
    }

    next() {
        /* eslint-disable no-unused-expressions */
        this._prevBtn?.unfocus();
        this._nextBtn?.focus();
        this.nextBtnEl?.click();
    }

    prev() {
        this._nextBtn?.unfocus();
        this._prevBtn?.focus();
        this.prevBtnEl?.click();
        /* eslint-enable */
    }

}
